import { Bar, ConsumptionBar } from "../../Types";
import "./index.css";
import ReactTooltip from "react-tooltip";
import { FilterObject } from "..";
import { Navigate, NavigateFunction } from "react-router";
import config from "../../config";

type Props = {
  data: Bar[];
  roof: number;
  navigate: (bar: Bar) => void;
};

export default function Graph({ data, roof, navigate }: Props) {
  const roofStart = { volume: roof };

  function getHighestVolumeBar(bars: Bar[]) {
    return bars.reduce((highestBar, bar) => {
      return highestBar.volume > bar.volume ? highestBar : bar;
    }, bars[0]);
  }

  const highestVolumeBar = getHighestVolumeBar(data);


  if (data.filter((bar) => {
    return bar.volume !== 0
  }).length === 0) {
    return <EmptyState />
  }

  return (
    <div className="graph" key={String(data)}>
      {data.map((bar, index) => {
        if (bar.volume === 0) return null;
        return (
          <div key={bar.label} onClick={() => navigate(bar)}
            data-tip={`${Math.round(bar.volume) + "kWh"}<br>${bar.label}<br>${bar.description
              }`}
            className="bar"
            style={{
              height:
                (bar.volume / Math.max(highestVolumeBar.volume, roof)) * 100 +
                "%",
              animationDelay: index * 0.02 + "s",
            }}
          >
            {" "}
          </div>
        );
      })}
      <ReactTooltip
        effect="solid"
        className="tooltip"
        multiline
        scrollHide
        place="left"
      />
      <YAxisLabel offset={0} highestVolumeBar={highestVolumeBar} />
      <YAxisLabel offset={1} highestVolumeBar={highestVolumeBar} />
      <YAxisLabel offset={2} highestVolumeBar={highestVolumeBar} />
      <YAxisLabel offset={3} highestVolumeBar={highestVolumeBar} />
    </div>
  );
}

type propsAxis = {
  offset: number;
  highestVolumeBar?: Bar;
};

function YAxisLabel({ offset, highestVolumeBar }: propsAxis) {
  return (
    <p
      className="y-axis-label"
      style={{ bottom: 100 - (25 * offset) + "%" }}
    >
      {Math.round(highestVolumeBar?.volume / (offset + 1)) + "kWh"}
    </p>
  );
}

function EmptyState() {

  return (
    <div style={{ alignItems: "center", justifyContent: "center", background: config.colors.primaryFaint }} className="graph">
      <p style={{ fontSize: 20, color: config.colors.primary }}>Ingen data för perioden!</p>
    </div>
  )
}

//Style
//Filter för data in i Graph, ex. månad,vecka, år
//Basera snitt på det också
